import { useState,useEffect } from "react";
import "../Styles/CreateProfile.css";
import { useSelector } from "react-redux";// replace with your actual logo path
import AppHeader from "./AppHeader";
import { useDispatch } from "react-redux";

import {  updateBusinessProfile } from "../Redux/Asycthunk";

import Footer from "./Footer";

 function normalizeLink(type, value) {
  if (!value) return "";

  const v = value.trim();

switch (type) {
  case "instagram":
    if (v.includes("http")) return v;
    return `https://instagram.com/${v.replace("@", "")}`;

  case "tiktok":
    if (v.includes("http")) return v;
    return `https://tiktok.com/@${v.replace("@", "")}`;

  case "facebook":
    if (v.includes("http")) return v;
    return `https://facebook.com/${v.replace("@", "")}`;

  case "x":
    if (v.includes("http")) return v;
    return `https://x.com/${v.replace("@", "")}`;

  case "snapchat":
    if (v.includes("http")) return v;
    return `https://snapchat.com/add/${v.replace("@", "")}`;

  case "youtube":
    if (v.includes("http")) return v;
    return `https://youtube.com/@${v.replace("@", "")}`;

  case "linkedin":
    if (v.includes("http")) return v;
    return `https://linkedin.com/in/${v.replace("@", "")}`;

  case "whatsappNumber":
    // WhatsApp: ONLY accept a phone number
    // Example: +44 7123 456789 → https://wa.me/447123456789
    const phone = v.replace(/[^\d]/g, "");

    if (!phone) return "";

    return `https://wa.me/${phone}`;

  case "website":
    if (v.includes("http")) return v;
    return `https://${v}`;

  case "googleReviewLink":
    return v;

  default:
    return v;
}
}

export default function CreateProfile() {
  const business = useSelector((state) => state.auth.business);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    instagram: "",
    tiktok: "",
    facebook: "",
    x: "",
    linkedin: "",
    snapchat: "",
    google: "",
    whatsappNumber: "",
    website: "",
    about: "",
    email: "",
    youtube: "",
  });

  

  const cleanedData = {
  instagram: normalizeLink("instagram", form.instagram),
  tiktok: normalizeLink("tiktok", form.tiktok),
  facebook: normalizeLink("facebook", form.facebook),
  whatsappNumber: normalizeLink("whatsappNumber", form.whatsappNumber),
  website: normalizeLink("website", form.website),
  googleReviewLink: normalizeLink("googleReviewLink", form.google),
  x: normalizeLink("x", form.x),
  linkedin: normalizeLink("linkedin", form.linkedin),
  snapchat: normalizeLink("snapchat", form.snapchat),
  youtube: normalizeLink("youtube", form.youtube),
  about: form.about,
  email: normalizeLink("email", form.email),
};



useEffect(() => {
  if (business) {
    setForm({
      businessName: business.businessName || "",
      about: business.about || "",
      logoUrl: business.logoUrl || null,

      instagram: business.socialLinks?.instagram || "",
      tiktok: business.socialLinks?.tiktok || "",
      facebook: business.socialLinks?.facebook || "",
      whatsappNumber: business.whatsappNumber || "",
      website: business?.website || "",
      google: business.reviewLinks?.google || "",
      x: business.socialLinks?.x || "",
      linkedin: business.socialLinks?.linkedin || "",
      snapchat: business.socialLinks?.snapchat || "",
      youtube: business.socialLinks?.youtube || "",
      email: business.email || ""
    });
  }
    
}, [business]);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await dispatch(updateBusinessProfile(cleanedData)).unwrap();

      if (res.message === "Business updated successfully") {
        window.location.href = "/dashboard/profile";
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = async () => {
    setLoading(true);

    try {
      const res = await dispatch(updateBusinessProfile({})).unwrap();

      if (res.message === "Business updated successfully") {
        window.location.href = "/dashboard/profile";
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  }

return (
  <>
    <AppHeader
      user={{ name: business?.businessName }}
      onLogout={handleLogout}
    />

    <div className="onboarding-container">
      <div className="onboarding-card">

        <p className="progress">Step 2 of 2</p>

        <h2 className="title">Add your links</h2>

        <p className="subtitle">
          Add the links you want customers to see. You can always change these later.
        </p>

        <form onSubmit={handleSubmit} className="form">

          {/* ABOUT */}
          <section className="section">
            <div className="section-header">
              <h3>About your business</h3>
              <span>Optional</span>
            </div>

            <div className="about-box">
              <textarea
                name="about"
                placeholder="Tell customers what you do in 1–2 lines"
                value={form.about}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value.length <= 120) {
                    handleChange(e);
                  }
                }}
              />

              <div className="char-count">
                {form.about?.length || 0}/120
              </div>
            </div>
          </section>


          {/* SOCIAL MEDIA */}
          <section className="section">
            <div className="section-header">
              <h3>Social media</h3>
              <span>Optional</span>
            </div>

            <div className="input-group">

              <input
                name="instagram"
                placeholder="Instagram username"
                value={form.instagram}
                onChange={handleChange}
                className="input"
              />

              <input
                name="tiktok"
                placeholder="TikTok username"
                value={form.tiktok}
                onChange={handleChange}
                className="input"
              />

              <input
                name="facebook"
                placeholder="Facebook profile"
                value={form.facebook}
                onChange={handleChange}
                className="input"
              />

              <input
                name="x"
                placeholder="X username"
                value={form.x}
                onChange={handleChange}
                className="input"
              />

              <input
                name="linkedin"
                placeholder="LinkedIn profile"
                value={form.linkedin}
                onChange={handleChange}
                className="input"
              />

              <input
                name="snapchat"
                placeholder="Snapchat username"
                value={form.snapchat}
                onChange={handleChange}
                className="input"
              />

              <input
                name="youtube"
                placeholder="YouTube channel"
                value={form.youtube}
                onChange={handleChange}
                className="input"
              />

            </div>
          </section>


          {/* REVIEWS */}
          <section className="section">
            <div className="section-header">
              <h3>Customer reviews</h3>
              <span>Optional</span>
            </div>

            <input
              name="google"
              placeholder="Google review link"
              value={form.google}
              onChange={handleChange}
              className="input"
            />
          </section>


          {/* CONTACT */}
          <section className="section">
            <div className="section-header">
              <h3>Contact & website</h3>
              <span>Optional</span>
            </div>

            <div className="input-group">

              <input
                name="whatsappNumber"
                placeholder="WhatsApp number (e.g. +44 7123 456789)"
                value={form.whatsappNumber}
                onChange={handleChange}
                className="input"
                type="tel"
                inputMode="tel"
              />

              <input
                name="email"
                placeholder="Email address"
                value={form.email}
                onChange={handleChange}
                className="input"
                type="email"
              />

              <input
                name="website"
                placeholder="Website"
                value={form.website}
                onChange={handleChange}
                className="input"
              />

            </div>
          </section>


          <button
            className="primary-btn"
            disabled={loading}
          >
            {loading ? "Saving..." : "Continue"}
          </button>

        </form>

        <button
          className="skip-btn"
          onClick={handleSkip}
          disabled={loading}
        >
          Skip for now
        </button>

      </div>
    </div>

    <Footer />

    <style jsx>{`

      .onboarding-container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 50px 20px;
        background: #0f0f0f;
        color: white;
      }

      .onboarding-card {
        width: 100%;
        max-width: 480px;
        padding: 34px;
        background: #181818;
        border: 1px solid rgba(255, 255, 255, 0.06);
        border-radius: 22px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
      }

      .progress {
        margin: 0 0 12px;
        font-size: 12px;
        font-weight: 500;
        color: #999;
        letter-spacing: 0.02em;
      }

      .title {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: -0.4px;
      }

      .subtitle {
        margin: 8px 0 28px;
        font-size: 14px;
        line-height: 1.5;
        color: #888;
      }

      .form {
        display: flex;
        flex-direction: column;
        gap: 26px;
      }

      /* SECTIONS */

      .section {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2px;
      }

      .section-header h3 {
        margin: 0;
        font-size: 13px;
        font-weight: 600;
        color: #e8e8e8;
      }

      .section-header span {
        font-size: 11px;
        color: #666;
      }

      /* INPUTS */

      .input-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .input {
        width: 100%;
        box-sizing: border-box;
        padding: 13px 14px;
        border-radius: 11px;
        border: 1px solid rgba(255, 255, 255, 0.06);
        outline: none;

        background: #222;
        color: white;

        font-size: 14px;
        transition: border 0.2s ease, background 0.2s ease,
          box-shadow 0.2s ease;
      }

      .input::placeholder {
        color: rgba(255, 255, 255, 0.32);
      }

      .input:focus {
        background: #202020;
        border-color: rgba(99, 85, 254, 0.7);
        box-shadow: 0 0 0 3px rgba(99, 85, 254, 0.1);
      }

      /* ABOUT */

      .about-box {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .about-box textarea {
        width: 100%;
        min-height: 88px;
        box-sizing: border-box;

        padding: 13px 14px;
        border-radius: 11px;

        background: #222;
        color: white;

        border: 1px solid rgba(255, 255, 255, 0.06);

        font-family: inherit;
        font-size: 14px;
        line-height: 1.5;

        resize: none;
        outline: none;

        transition: border 0.2s ease, box-shadow 0.2s ease,
          background 0.2s ease;
      }

      .about-box textarea::placeholder {
        color: rgba(255, 255, 255, 0.32);
      }

      .about-box textarea:focus {
        background: #202020;
        border-color: rgba(99, 85, 254, 0.7);
        box-shadow: 0 0 0 3px rgba(99, 85, 254, 0.1);
      }

      .char-count {
        font-size: 11px;
        color: #666;
        text-align: right;
      }

      /* BUTTON */

      .primary-btn {
        width: 100%;
        padding: 14px;

        border: none;
        border-radius: 11px;

        background: #6355fe;
        color: white;

        font-size: 14px;
        font-weight: 600;

        cursor: pointer;

        margin-top: 2px;

        transition: opacity 0.2s ease, transform 0.2s ease;
      }

      .primary-btn:hover {
        opacity: 0.92;
      }

      .primary-btn:active {
        transform: scale(0.99);
      }

      .primary-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      /* SKIP */

      .skip-btn {
        display: block;
        margin: 16px auto 0;

        background: transparent;
        border: none;

        color: #777;

        cursor: pointer;
        font-size: 13px;
      }

      .skip-btn:hover {
        color: #aaa;
      }

      @media (max-width: 600px) {

        .onboarding-container {
          padding: 24px 14px;
        }

        .onboarding-card {
          padding: 26px 20px;
          border-radius: 18px;
        }

        .title {
          font-size: 22px;
        }

        .form {
          gap: 22px;
        }

      }

    `}</style>
  </>
);
}